module.exports = __webpack_public_path__ + "img/2_1-residenziale-biblioteca-1.9014ba10.png";